import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { LoadingBlock } from "@/components/common";
import { RangeBar } from "./RangeBar";
import { KpiCards } from "./KpiCards";
import { InsightsPanel } from "./InsightsPanel";
import { TrendCard } from "./TrendCard";
import { CategoryCard } from "./CategoryCard";
import { OutletTable } from "./OutletTable";
import { ItemsTable } from "./ItemsTable";

export const rangeParams = (brand, s) => ({
  brand, preset: s.preset, ...(s.preset === "custom" ? { date_from: s.from, date_to: s.to } : {}),
  ...(s.outlets?.length ? { outlet: s.outlets.join("|") } : {}),
  ...(s.dept ? { department: s.dept } : {}),
});

export const BrandAnalytics = ({ brand, s, update }) => {
  const [data, setData] = useState(null);
  const ready = s.preset !== "custom" || (s.from && s.to);
  const key = JSON.stringify(rangeParams(brand, s));

  useEffect(() => {
    if (!ready) return;
    setData(null);
    api.get("/analytics", { params: JSON.parse(key) }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [key, ready]);

  return (
    <div className="space-y-6" data-testid="brand-analytics">
      <RangeBar brand={brand} s={s} update={update} range={ready ? data?.range : null} />
      {!ready ? <p className="text-sm text-slate-500" data-testid="custom-range-hint">Pick a start and end date.</p> : !data ? <LoadingBlock rows={5} /> : (
        <>
          <KpiCards k={data.kpis} compare={s.compare} />
          <InsightsPanel params={JSON.parse(key)} />
          <div className="grid gap-6 xl:grid-cols-2">
            <TrendCard data={data.trend} compare={s.compare} brand={brand} />
            <CategoryCard data={data.categories} compare={s.compare} brand={brand} />
          </div>
          <OutletTable rows={data.outlets} compare={s.compare} brand={brand} range={data.range} />
          <ItemsTable rows={data.items} compare={s.compare} />
        </>
      )}
    </div>
  );
};
